<template>
  <div class="modern-container">
    <!-- Overlay de loading redesenhado -->
    <v-overlay :value="isLoading" opacity="0.8" color="#1E293B" z-index="10">
      <v-progress-circular
        indeterminate
        size="72"
        width="4"
        color="#3B82F6"
        class="loading-spinner"
      ></v-progress-circular>
    </v-overlay>

    <!-- Cabeçalho moderno -->
    <div class="modern-header">
      <div class="header-content">
        <div class="header-text">
          <h1 class="header-title">Gerenciamento de Permissões</h1>
        </div>
        <v-btn
          color="#3B82F6"
          dark
          depressed
          large
          @click="loadItems"
          class="refresh-btn"
        >
          <v-icon left>mdi-refresh</v-icon>
          Atualizar
        </v-btn>
      </div>
    </div>

    <!-- Barra de pesquisa premium -->
    <div class="modern-search">
      <v-text-field
        v-model="search"
        outlined
        dense
        hide-details
        placeholder="Pesquisar menu..."
        prepend-inner-icon="mdi-magnify"
        clearable
        class="modern-search-field"
        color="#3B82F6"
      >
        <template v-slot:prepend-inner>
          <v-icon color="#64748B">mdi-magnify</v-icon>
        </template>
      </v-text-field>
    </div>

    <!-- Tabela moderna -->
    <v-card class="modern-table-card" elevation="0">
      <v-data-table
        :headers="headers"
        :items="itensMenuAll"
        :search="search"
        :items-per-page="10"
        :loading="isLoading"
        loading-text="Carregando dados..."
        class="modern-data-table"
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 20],
          'items-per-page-text': 'Itens por página',
          'page-text': '{0}-{1} de {2}'
        }"
      >
        <!-- Índice estilizado -->
        <template v-slot:item.index="{ index }">
          <div class="index-badge">
            {{ index + 1 }}
          </div>
        </template>

        <!-- Nome do menu com destaque -->
        <template v-slot:item.menu="{ item }">
          <div class="menu-item">
            <v-icon color="#3B82F6" small class="mr-2">mdi-folder-outline</v-icon>
            <span class="menu-name">{{ item.menu }}</span>
          </div>
        </template>

        <!-- Autor com avatar e tooltip -->
        <template v-slot:item.createdBy="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div class="author-item" v-on="on">
                <v-avatar size="32" color="#EFF6FF" class="mr-2">
                  <span class="initials">{{ getInitials(item.createdBy) }}</span>
                </v-avatar>
                <span class="author-name">{{ item.createdBy }}</span>
              </div>
            </template>
            <span>Criado por {{ item.createdBy }}</span>
          </v-tooltip>
        </template>

        <!-- Data formatada -->
        <template v-slot:item.data_created="{ item }">
          <div class="date-item">
            <v-icon small color="#64748B" class="mr-1">mdi-calendar</v-icon>
            <span>{{ formatDate(item.data_created) }}</span>
          </div>
        </template>

        <!-- Hora formatada -->
        <template v-slot:item.hora_created="{ item }">
          <div class="time-item">
            <v-icon small color="#64748B" class="mr-1">mdi-clock</v-icon>
            <span>{{ item.hora_created }}</span>
          </div>
        </template>

        <!-- Ações com efeito hover -->
        <template v-slot:item.action="{ item }">
          <v-btn
            color="#3B82F6"
            depressed
            small
            @click="selectFunction(item)"
            class="action-button"
          >
            <v-icon left small>mdi-chevron-right</v-icon>
            Ver funções
          </v-btn>
        </template>

        <!-- Estado vazio personalizado -->
        <template v-slot:no-data>
          <div class="empty-state">
            <h3 class="empty-title">Nenhum menu encontrado</h3>
            <v-btn
              color="#3B82F6"
              depressed
              class="empty-action"
              @click="loadItems"
            >
              <v-icon left>mdi-refresh</v-icon>
              Tentar novamente
            </v-btn>
          </div>
        </template>

        <!-- Sem resultados na pesquisa -->
        <template v-slot:no-results>
          <div class="empty-state">
            <h3 class="empty-title">Nenhum resultado encontrado</h3>
            <p class="empty-description">
              Sua pesquisa por "{{ search }}" não retornou resultados
            </p>
            <v-btn
              color="#3B82F6"
              depressed
              class="empty-action"
              @click="search = ''"
            >
              <v-icon left>mdi-backspace</v-icon>
              Limpar pesquisa
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import funcoesUsuarioService from '@/services/funcoesUsuarioService';
import Swal from 'sweetalert2';
export default {
  data: () => ({
    itensMenuAll: [],
    isLoading: false,
    search: '',
    headers: [
      { text: "#", value: "index", width: '80px', align: 'center', sortable: false },
      { text: "MENU", value: "menu", width: '30%' },
      { text: "CRIADO POR", value: "createdBy", width: '25%' },
      { text: "DATA", value: "data_created", width: '20%' },
      { text: "HORA", value: "hora_created", width: '15%' },
      { text: "AÇÕES", value: "action", align: 'center', width: '150px', sortable: false }
    ]
  }),

  async created() {
    await this.loadItems();
  },

  methods: {
    async loadItems() {
      this.isLoading = true;
      try {
        this.itensMenuAll = await funcoesUsuarioService.getFuncoesByMenu();
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um problema ao tentar carregar a lista de menus e funções. Por favor, tente novamente mais tarde.', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    selectFunction(item) {
      this.$store.state.funcaoUsuarioMenuSelected = item;
      this.$router.push('/administracao/funcoesMenu');
    },

    getInitials(name) {
      if (!name) return '';
      const parts = name.split(' ');
      return parts.map(p => p[0]).join('').toUpperCase().substring(0, 2);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('pt-BR', options);
    }
  }
};
</script>

<style scoped>
.modern-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  background-color: #F8FAFC;
}

.modern-header {
  margin-bottom: 24px;
  padding: 24px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1E293B;
  margin-bottom: 4px;
}

.refresh-btn {
  border-radius: 8px;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(59, 130, 246, 0.2);
}

.modern-search {
  width: 50%;
  margin: 0 auto 24px;
  padding: 0 24px;
}

.modern-search-field {
  background-color: white;
  border-radius: 8px;
}

.modern-search-field >>> .v-input__slot {
  min-height: 48px !important;
}

.modern-table-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.modern-data-table {
  background-color: transparent;
}

.modern-data-table >>> thead tr {
  background-color: #F1F5F9;
}

.modern-data-table >>> thead th {
  color: #1E293B !important;
  font-weight: 600 !important;
  font-size: 0.875rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.modern-data-table >>> tbody tr {
  transition: all 0.2s ease;
}

.modern-data-table >>> tbody tr:hover {
  background-color: #F8FAFC !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.index-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: #EFF6FF;
  color: #3B82F6;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.875rem;
}

.menu-item {
  display: flex;
  align-items: center;
}

.menu-name {
  font-weight: 500;
  color: #1E293B;
}

.author-item {
  display: flex;
  align-items: center;
}

.initials {
  color: #3B82F6;
  font-weight: 600;
  font-size: 0.75rem;
}

.author-name {
  font-weight: 500;
  color: #1E293B;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date-item, .time-item {
  display: flex;
  align-items: center;
  color: #64748B;
  font-size: 0.875rem;
}

.action-button {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(59, 130, 246, 0.2);
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.2);
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

.empty-image {
  margin: 0 auto 16px;
}

.empty-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1E293B;
  margin-bottom: 8px;
}

.empty-description {
  font-size: 1rem;
  color: #64748B;
  max-width: 400px;
  margin: 0 auto 16px;
}

.empty-action {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
  border-radius: 6px;
}

.loading-spinner {
  margin-bottom: 16px;
}

/* Responsividade */
@media (max-width: 960px) {
  .modern-container {
    padding: 16px;
  }

  .modern-header {
    padding: 16px;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .refresh-btn {
    margin-top: 16px;
    width: 100%;
  }

  .modern-search {
    padding: 0;
  }

  .modern-data-table >>> thead th {
    font-size: 0.75rem;
  }
}

@media (max-width: 600px) {
  .header-title {
    font-size: 1.5rem;
  }

  .modern-data-table >>> td {
    padding: 8px 4px !important;
  }

  .action-button {
    font-size: 0.75rem;
    padding: 0 8px;
  }
}
</style>
